import { IIconProps } from './add';

interface IIconPolygon extends IIconProps {
  width?: string;
  height?: string;
  fill: string;
}

export const IconPolygon = ({
  style = {},
  cy,
  fill,
  height = '20',
  width = '20',
}: IIconPolygon) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 13"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      data-cy={`IconPolygon${cy}`}
    >
      <path d="M9.33333 1.83333H8V0.5H9.33333V1.83333ZM8 12.5H9.33333V10.7733L11.06 12.5L12 11.56L10.2733 9.83333H12V8.5H8V12.5ZM10.6667 4.5H12V3.16667H10.6667V4.5ZM10.6667 7.16667H12V5.83333H10.6667V7.16667ZM5.33333 12.5H6.66667V11.1667H5.33333V12.5ZM2.66667 1.83333H4V0.5H2.66667V1.83333ZM0 9.83333H1.33333V8.5H0V9.83333ZM1.33333 12.5V11.1667H0C0 11.9 0.6 12.5 1.33333 12.5ZM10.6667 0.5V1.83333H12C12 1.1 11.4 0.5 10.6667 0.5ZM5.33333 1.83333H6.66667V0.5H5.33333V1.83333ZM0 4.5H1.33333V3.16667H0V4.5ZM2.66667 12.5H4V11.1667H2.66667V12.5ZM0 7.16667H1.33333V5.83333H0V7.16667ZM0 1.83333H1.33333V0.5C0.6 0.5 0 1.1 0 1.83333Z" />
    </svg>
  );
};
